import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SalesAMCreate from './AraiManufacturing/Create';
import SalesPICreate from './PumpSpareInternational/Create';
import SalesPDCreate from './PumpSpareDomestic/Create';
import SalesMDCreate from './ManufacturingDomestic/Create';

function SalesCreate() {
    const [salestype, setsalestype] = useState('');
    const [salescategory, setsalescategory] = useState('');
    const [salestypeDisabled, setsalestypeDisabled] = useState(false);
    const [salescategoryDisabled, setsalescategoryDisabled] = useState(false);

    const handlesalestypeChange = (event) => {
        const selectedsalestype = event.target.value;
        setsalestype(selectedsalestype);
        setsalescategory('');
        setsalescategoryDisabled(false);
        setsalestypeDisabled(true);
    };

    const handlesalescategoryChange = (event) => {
        setsalescategory(event.target.value);
        setsalescategoryDisabled(true);
    };

    const PageDisplay = () => {
        if (salestype === 'Pump Spare') {
            if (salescategory === 'Domestic') {
                return <SalesPDCreate />;
            } else if (salescategory === 'International') {
                return <SalesPICreate />;
            }
        } else if (salestype === 'Manufacturing') {
            if (salescategory === 'Domestic') {
                return <SalesMDCreate />;
            } else if (salescategory === 'International') {
                return <SalesAMCreate />;
            }
        }
        return null;
    };

    return (
            <Card className="card">
                <Card.Header className="card-header">
                    <h6>ADD SALES</h6>
                    <Link to="/salesindex/1">
                        <button className="button-70">BACK</button>
                    </Link>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md="6">
                            <Form.Group>
                                <Form.Label>Select Product Type:</Form.Label>
                                <Form.Select
                                    onChange={handlesalestypeChange}
                                    value={salestype}
                                    disabled={salestypeDisabled}
                                >
                                    <option value="">--Please choose an option--</option>
                                    <option value="Pump Spare">Pump Spare</option>
                                    <option value="Manufacturing">Manufacturing</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {(salestype === 'Pump Spare' || salestype === 'Manufacturing') && (
                            <Col md="6">
                                <Form.Group>
                                    <Form.Label>Select Product Category:</Form.Label>
                                    <Form.Select
                                        onChange={handlesalescategoryChange}
                                        value={salescategory}
                                        disabled={salescategoryDisabled}
                                    >
                                        <option value="">--Please choose an option--</option>
                                        <option value="Domestic">Domestic</option>
                                        <option value="International">International</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        )}
                        {PageDisplay()}
                    </Row>
                </Card.Body>
            </Card>
    );
}

export default SalesCreate;
